/* ═══════════════════════════════════════
   KAZEHAUS — main.js v3
   Cart: fully JS-driven (fetch /cart.js)
   Upsell: popup + cart drawer suggestions
═══════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {

  /* ─────────────────────────────────────
     HELPERS
  ───────────────────────────────────── */
  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  }

  function imgSrc(url, size) {
    if (!url) return '';
    return url.replace(/(\.[^.?]+)(\?.*)?$/, `_${size}$1$2`);
  }

  /* ─────────────────────────────────────
     PAGE SYSTEM (homepage)
  ───────────────────────────────────── */
  const pageEls = Array.from(document.querySelectorAll('.homepage .page'));
  if (pageEls.length > 0) initHomepage(pageEls);

  function initHomepage(pages) {
    // Vertical scroll is now FREE — browser handles it naturally.
    // We only manage the horizontal sliders within each section.

    /* ── Hero Slider ── */
    let hCur = 0, hAnim = false;
    const hTotal = 4;
    const heroTrack = document.getElementById('heroTrack');
    const hSlides   = document.querySelectorAll('.hslide');
    const hDots     = document.querySelectorAll('.hdot');
    const heroNum   = document.getElementById('heroNum');

    function heroGo(idx) {
      if (hAnim || idx === hCur || idx < 0 || idx >= hTotal) return;
      hAnim = true;
      hSlides[hCur]?.classList.remove('active');
      hDots[hCur]?.classList.remove('active');
      hCur = idx;
      if (heroTrack) heroTrack.style.transform = `translateX(-${hCur * 100}vw)`;
      hSlides[hCur]?.classList.add('active');
      hDots[hCur]?.classList.add('active');
      if (heroNum) heroNum.textContent = String(hCur + 1).padStart(2, '0');
      setTimeout(() => { hAnim = false; }, 950);
    }

    hDots.forEach(d => d.addEventListener('click', () => { heroGo(+d.dataset.slide); resetHTimer(); }));
    let hTimer = setInterval(() => heroGo((hCur + 1) % hTotal), 6000);
    function resetHTimer() { clearInterval(hTimer); hTimer = setInterval(() => heroGo((hCur + 1) % hTotal), 6000); }

    /* ── Collection Slider (desktop) ── */
    let cCur = 0; const cTotal = 3;
    const collTrack = document.getElementById('collTrack');
    const cDots = document.querySelectorAll('.cdot');
    function collGo(idx) {
      const t = Math.max(0, Math.min(cTotal - 1, idx));
      if (t === cCur) return;
      cCur = t;
      if (collTrack) collTrack.style.transform = `translateX(-${cCur * 100}vw)`;
      cDots.forEach((d, i) => d.classList.toggle('active', i === cCur));
    }
    document.getElementById('collPrev')?.addEventListener('click', () => collGo(cCur - 1));
    document.getElementById('collNext')?.addEventListener('click', () => collGo(cCur + 1));
    cDots.forEach(d => d.addEventListener('click', () => collGo(+d.dataset.slide)));

    /* ── Featured Slider ── */
    let fCur = 0; const fTotal = 3;
    const featTrack = document.getElementById('featTrack');
    const fDots = document.querySelectorAll('.fdot');
    function featGo(idx) {
      const t = Math.max(0, Math.min(fTotal - 1, idx));
      if (t === fCur) return;
      fCur = t;
      if (featTrack) featTrack.style.transform = `translateX(-${fCur * 100}vw)`;
      fDots.forEach((d, i) => d.classList.toggle('active', i === fCur));
    }
    document.getElementById('featPrev')?.addEventListener('click', () => featGo(fCur - 1));
    document.getElementById('featNext')?.addEventListener('click', () => featGo(fCur + 1));
    fDots.forEach(d => d.addEventListener('click', () => featGo(+d.dataset.slide)));

    // Hide scroll-down button (no longer needed)
    const sd = document.getElementById('scrollDown');
    if (sd) sd.style.display = 'none';
  }

  /* ─────────────────────────────────────
     CART SYSTEM — fully JS driven
  ───────────────────────────────────── */
  const cartDrawer  = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartBody    = document.getElementById('cartBody');
  const cartFooter  = document.getElementById('cartFooter');
  const cartTotal   = document.getElementById('cartTotal');
  const drawerCount = document.getElementById('drawerCount');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('show');
    refreshCartDrawer();
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('show');
  }

  document.querySelectorAll('#openCart, #sideCart').forEach(b => b?.addEventListener('click', openCart));
  document.getElementById('closeCart')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  /* Render cart drawer from cart data */
  async function refreshCartDrawer() {
    if (!cartBody) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      renderCartDrawer(cart);
    } catch(e) {
      cartBody.innerHTML = '<p style="padding:20px;color:var(--dim)">Could not load cart.</p>';
    }
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;

    // Update counts
    updateCartCounts(cart.item_count, cart.total_price);

    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>${window.carinaT ? window.carinaT('cart_empty_msg') : 'Your cart is empty'}</p>
          <a href="/collections/all" class="btn-primary btn-sm" onclick="closeCart&&closeCart()">${window.carinaT ? window.carinaT('browse_all_rugs') : 'Browse All Rugs'}</a>
        </div>`;
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    // Render items
    let html = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}" class="cart-item__img">
          <img src="${imgSrc(item.image, '120x120_crop_center')}" alt="${item.title}" width="70" height="70" loading="lazy">
        </a>
        <div class="cart-item__info">
          <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__footer">
            <div class="cart-item__qty">
              <button class="qty-btn" data-action="decrease" data-key="${item.key}">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" data-action="increase" data-key="${item.key}">+</button>
            </div>
            <span class="cart-item__price">${money(item.line_price)}</span>
          </div>
        </div>
        <button class="cart-item__remove" data-key="${item.key}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>`).join('');

    // Upsell section
    html += `
      <div class="cart-upsell" id="cartUpsell">
        <p class="cart-upsell__title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
          ${window.carinaT ? window.carinaT('might_also_like') : 'You might also like:'}
        </p>
        <div class="cart-upsell__products" id="cartUpsellProducts">
          <div class="upsell-loading">${window.carinaT ? window.carinaT('finding_recommendations') : 'Loading…'}</div>
        </div>
      </div>`;

    cartBody.innerHTML = html;
    if (cartFooter) {
      cartFooter.style.display = 'block';
      if (cartTotal) cartTotal.textContent = money(cart.total_price);
    }

    // Load upsell suggestions
    loadCartUpsell(cart.items.map(i => i.handle));
  }

  function updateCartCounts(count, totalPrice) {
    document.querySelectorAll('#cartCount, #sideBadge').forEach(el => { if (el) el.textContent = count; });
    if (drawerCount) drawerCount.textContent = count > 0 ? `(${count})` : '';
    if (cartTotal) cartTotal.textContent = money(totalPrice);
  }

  /* Qty change & remove — event delegation */
  cartBody?.addEventListener('click', async e => {
    const qtyBtn = e.target.closest('.qty-btn[data-action]');
    const removeBtn = e.target.closest('.cart-item__remove');

    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const valEl = qtyBtn.parentElement.querySelector('.qty-val');
      let qty = parseInt(valEl?.textContent || '1');
      qty = qtyBtn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      const cart = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(r => r.json());
      renderCartDrawer(cart);
    }

    if (removeBtn) {
      const key = removeBtn.dataset.key;
      const cart = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(r => r.json());
      renderCartDrawer(cart);
    }
  });

  /* ─────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.quick-add, .btn-add-to-cart');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const origHTML = btn.innerHTML;
    const addingText = window.carinaT ? window.carinaT('adding_dots') : 'Adding…';
    const addedText = window.carinaT ? window.carinaT('added_check') : 'Added ✓';
    const errorText = window.carinaT ? window.carinaT('error_word') : 'Error';
    btn.innerHTML = addingText; btn.disabled = true;
    try {
      const qty = parseInt(document.getElementById('productQty')?.value || '1');
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      });
      if (res.ok) {
        btn.innerHTML = addedText;
        const cart = await fetch('/cart.js').then(r => r.json());
        updateCartCounts(cart.item_count, cart.total_price);
        // Update mobile nav badge
        const mobBadge = document.getElementById('mobCartBadge');
        if (mobBadge) mobBadge.textContent = cart.item_count > 0 ? cart.item_count : '';
        // Show upsell popup
        const handle = btn.closest('[data-product-handle]')?.dataset.productHandle
          || window.location.pathname.split('/products/')[1]?.split('?')[0] || '';
        showUpsellPopup(handle);
        // Refresh cart drawer if open
        if (document.getElementById('cartDrawer')?.classList.contains('open')) {
          refreshCartDrawer();
        }
        setTimeout(() => { btn.innerHTML = origHTML; btn.disabled = false; }, 2000);
      } else {
        const errData = await res.json().catch(() => ({}));
        btn.innerHTML = errData.description || errorText;
        setTimeout(() => { btn.innerHTML = origHTML; btn.disabled = false; }, 2500);
      }
    } catch(err) { 
      console.error('Cart error:', err);
      btn.innerHTML = origHTML; btn.disabled = false; 
    }
  });

  /* ─────────────────────────────────────
     UPSELL — fetch products
  ───────────────────────────────────── */
  async function fetchSuggestions(excludeHandles, limit = 3) {
    // Öncelik: URL'deki koleksiyon > ürünün kendi koleksiyonu > all
    const urlCol = window.location.pathname.match(/\/collections\/([^\/]+)/)?.[1];
    const dataCol = document.getElementById('obtSection')?.dataset.collection;
    const col = urlCol || dataCol || 'all';
    try {
      const data = await fetch(`/collections/${col}/products.json?limit=20`).then(r => r.json());
      const filtered = data.products.filter(p => !excludeHandles.includes(p.handle) && p.available);
      return filtered.sort(() => Math.random() - 0.5).slice(0, limit);
    } catch {
      try {
        const data = await fetch('/collections/all/products.json?limit=20').then(r => r.json());
        return data.products.filter(p => !excludeHandles.includes(p.handle) && p.available)
          .sort(() => Math.random() - 0.5).slice(0, limit);
      } catch { return []; }
    }
  }

  function buildUpsellCard(p, compact = false) {
    const img = p.images?.[0]?.src ? imgSrc(p.images[0].src, compact ? '80x80_crop_center' : '160x160_crop_center') : '';
    const price = money(p.variants?.[0]?.price || 0);
    const vid = p.variants?.[0]?.id;
    if (compact) return `
      <div class="upsell-card upsell-card--sm">
        ${img ? `<img src="${img}" alt="${p.title}" width="56" height="56" loading="lazy">` : ''}
        <div class="upsell-card__info">
          <p class="upsell-card__name">${p.title.substring(0,30)}</p>
          <p class="upsell-card__price">${price}</p>
        </div>
        <button class="upsell-card__btn quick-add" data-variant-id="${vid}" title="Add to cart">+</button>
      </div>`;
    return `
      <div class="upsell-card">
        ${img ? `<img src="${img}" alt="${p.title}" width="90" height="90" loading="lazy">` : ''}
        <div class="upsell-card__info">
          <p class="upsell-card__name">${p.title.substring(0,40)}</p>
          <p class="upsell-card__price">${price}</p>
          <button class="btn-primary btn-sm quick-add" data-variant-id="${vid}">${window.carinaT ? window.carinaT('add_to_cart') : 'Add to Cart'}</button>
        </div>
      </div>`;
  }

  /* ─────────────────────────────────────
     UPSELL POPUP
  ───────────────────────────────────── */
  const upsellPopup   = document.getElementById('upsellPopup');
  const upsellOverlay = document.getElementById('upsellOverlay');
  let upsellTimer = null;

  function showUpsellPopup(currentHandle) {
    if (!upsellPopup) return;
    upsellPopup.classList.add('open');
    upsellOverlay?.classList.add('show');

    const container = document.getElementById('upsellProducts');
    if (container) {
      container.innerHTML = '<div class="upsell-loading">Finding recommendations…</div>';
      fetchSuggestions(currentHandle ? [currentHandle] : [], 3).then(products => {
        if (!products.length) {
          container.innerHTML = '<p style="font-size:12px;color:var(--dim);text-align:center;padding:12px 0">Check out our full collection!</p>';
          return;
        }
        container.innerHTML = products.map(p => buildUpsellCard(p, false)).join('');
      });
    }

    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(closeUpsellPopup, 9000);
  }

  function closeUpsellPopup() {
    clearTimeout(upsellTimer);
    upsellPopup?.classList.remove('open');
    upsellOverlay?.classList.remove('show');
  }

  document.getElementById('upsellClose')?.addEventListener('click', closeUpsellPopup);
  upsellOverlay?.addEventListener('click', closeUpsellPopup);
  document.getElementById('upsellViewCart')?.addEventListener('click', () => { closeUpsellPopup(); openCart(); });

  /* ─────────────────────────────────────
     CART DRAWER UPSELL
  ───────────────────────────────────── */
  async function loadCartUpsell(cartHandles) {
    const container = document.getElementById('cartUpsellProducts');
    if (!container) return;
    const products = await fetchSuggestions(cartHandles, 3);
    if (!products.length) {
      document.getElementById('cartUpsell')?.style.setProperty('display', 'none');
      return;
    }
    container.innerHTML = products.map(p => buildUpsellCard(p, true)).join('');
  }

  /* ─────────────────────────────────────
     OFTEN BOUGHT TOGETHER (product page)
  ───────────────────────────────────── */
  const obtSection = document.getElementById('obtSection');
  if (obtSection) {
    const handle = window.location.pathname.split('/products/')[1]?.split('?')[0] || '';
    const obtContainer = document.getElementById('obtSuggestions');
    const obtTotal     = document.getElementById('obtTotal');
    const obtAddAll    = document.getElementById('obtAddAll');
    const mainPrice    = parseInt(obtAddAll?.dataset.mainPrice || '0');
    const mainId       = parseInt(obtAddAll?.dataset.mainId || '0');
    let suggId = null, suggPrice = 0;

    fetchSuggestions([handle], 1).then(products => {
      if (!products.length) { obtSection.style.display = 'none'; return; }
      const p = products[0];
      suggId    = p.variants?.[0]?.id;
      suggPrice = p.variants?.[0]?.price || 0;
      const img = p.images?.[0]?.src ? imgSrc(p.images[0].src, '160x160_crop_center') : '';
      if (obtContainer) obtContainer.innerHTML = `
        <div class="obt-main">
          <div class="obt-main__img">
            ${img ? `<img src="${img}" alt="${p.title}" width="80" height="80" loading="lazy">` : ''}
            <span class="obt-check active">✓</span>
          </div>
          <div class="obt-main__info">
            <p class="obt-main__name">${p.title.substring(0,40)}</p>
            <p class="obt-main__price">${money(suggPrice)}</p>
          </div>
        </div>`;
      if (obtTotal) obtTotal.textContent = money(mainPrice + suggPrice);
      if (obtAddAll) obtAddAll.textContent = 'Add Both to Cart';
    });

    obtAddAll?.addEventListener('click', async () => {
      if (!mainId) return;
      obtAddAll.textContent = window.carinaT ? window.carinaT('adding_dots') : 'Adding…'; obtAddAll.disabled = true;
      const items = [{ id: mainId, quantity: 1 }];
      if (suggId) items.push({ id: suggId, quantity: 1 });
      try {
        const cart = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        }).then(r => r.json());
        obtAddAll.textContent = window.carinaT ? window.carinaT('added_check') : 'Added ✓';
        updateCartCounts(cart.items?.length || 0, cart.total_price || 0);
        setTimeout(() => { openCart(); obtAddAll.textContent = 'Add Both to Cart'; obtAddAll.disabled = false; }, 800);
      } catch { obtAddAll.textContent = 'Add Both to Cart'; obtAddAll.disabled = false; }
    });
  }

  /* ─────────────────────────────────────
     FILTER PANEL TOGGLE
  ───────────────────────────────────── */
  const filterToggle = document.getElementById('filterToggle');
  const filterPanel  = document.getElementById('filterPanel');

  if (filterToggle && filterPanel) {
    // Count active filters and show badge
    const activeCount = document.querySelectorAll('.filter-option--active').length;
    const countBadge  = document.getElementById('filterActiveCount');
    if (activeCount > 0 && countBadge) {
      countBadge.textContent = activeCount;
      countBadge.style.display = 'flex';
      // Auto-open panel if filters are active
      filterPanel.classList.add('open');
      filterToggle.setAttribute('aria-expanded', 'true');
      filterPanel.setAttribute('aria-hidden', 'false');
    }

    filterToggle.addEventListener('click', () => {
      const isOpen = filterPanel.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      filterPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  /* ─────────────────────────────────────
     FAQ
  ───────────────────────────────────── */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ─────────────────────────────────────
     PRODUCT CARE & SPECIFICATIONS ACCORDION
  ───────────────────────────────────── */
  document.querySelectorAll('.pcs-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.pcs-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ─────────────────────────────────────
     MOBILE MENU
  ───────────────────────────────────── */
  const mobileMenu    = document.getElementById('mobileMenu');
  const mobileOverlay = document.getElementById('mobileMenuOverlay');
  function openMobileMenu()  { mobileMenu?.classList.add('open');    mobileOverlay?.classList.add('show'); }
  function closeMobileMenu() { mobileMenu?.classList.remove('open'); mobileOverlay?.classList.remove('show'); }
  document.getElementById('mobileMenuToggle')?.addEventListener('click', openMobileMenu);
  document.getElementById('mobileMenuClose')?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  /* ─────────────────────────────────────
     LANGUAGE SWITCHER
  ───────────────────────────────────── */
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.lang-btn').forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed','false'); });
      btn.classList.add('active'); btn.setAttribute('aria-pressed','true');
      document.documentElement.lang = btn.dataset.lang;
    });
  });

  /* ─────────────────────────────────────
     PRODUCT PAGE — GALLERY
  ───────────────────────────────────── */
  const mainImg = document.getElementById('mainImage');
  const thumbs  = document.querySelectorAll('.gallery-thumb');
  let imgIndex  = 0;
  thumbs.forEach((t, i) => t.addEventListener('click', () => {
    thumbs.forEach(th => th.classList.remove('gallery-thumb--active'));
    t.classList.add('gallery-thumb--active');
    if (mainImg) mainImg.src = t.dataset.src;
    imgIndex = i;
  }));
  document.getElementById('galleryPrev')?.addEventListener('click', () => { imgIndex = (imgIndex - 1 + thumbs.length) % thumbs.length; thumbs[imgIndex]?.click(); });
  document.getElementById('galleryNext')?.addEventListener('click', () => { imgIndex = (imgIndex + 1) % thumbs.length; thumbs[imgIndex]?.click(); });

  /* ─────────────────────────────────────
     PRODUCT — VARIANTS & QTY
  ───────────────────────────────────── */
  // Load variant data from page
  let productVariants = [];
  try {
    const variantDataEl = document.getElementById('productVariantData');
    if (variantDataEl) {
      productVariants = JSON.parse(variantDataEl.textContent).variants;
    }
  } catch(e) { console.warn('variant data parse error', e); }

  // Para formatı
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style:'currency', currency:'USD' }).format(cents / 100);
  }

  // Değer normalize — boşluk/karakter farklarını yok say
  function normVal(s) {
    return (s == null ? '' : String(s)).trim().replace(/\s+/g, ' ').toLowerCase();
  }

  // Seçili variant'ı bul — tüm option'ları karşılaştır
  function getSelectedVariant() {
    const groups = document.querySelectorAll('.variant-options');
    if (!groups.length) return productVariants[0] || null;

    const selected = [];
    groups.forEach(group => {
      const active = group.querySelector('.variant-btn--active');
      selected.push(active ? active.dataset.value : null);
    });

    const match = productVariants.find(v => {
      const opts = [v.option1, v.option2, v.option3];
      return selected.every((val, i) => {
        if (val === null) return true;
        return normVal(opts[i]) === normVal(val);
      });
    });

    // Eşleşme bulunamazsa ilk variant'a düşme YOK — null dön, eski fiyat korunur
    return match || null;
  }

  // Sayfadaki tüm fiyat + buton + link'leri güncelle
  function applyVariant(variant) {
    if (!variant) return;

    // 1. Tüm "sepete ekle" butonları
    document.querySelectorAll('.btn-add-to-cart, .mob-sticky-buy__btn').forEach(btn => {
      btn.dataset.variantId = String(variant.id);
      btn.disabled = !variant.available;
      const label = btn.querySelector('[data-i18n="add_to_cart"], [data-i18n="sold_out"]');
      if (label) {
        label.textContent    = variant.available ? (window.carinaT ? window.carinaT('add_to_cart') : 'Add to Cart') : (window.carinaT ? window.carinaT('sold_out') : 'Sold Out');
        label.dataset.i18n   = variant.available ? 'add_to_cart' : 'sold_out';
      }
    });

    // 2. Ana fiyat (desktop + mobil)
    const priceEls = document.querySelectorAll('.price-current');
    priceEls.forEach(el => { el.textContent = formatMoney(variant.price); });

    // 3. Karşılaştırma fiyatı (compare_at_price) — variant JSON'a eklenmeli
    if (variant.compare_price && variant.compare_price > variant.price) {
      document.querySelectorAll('.price-compare').forEach(el => {
        el.textContent = formatMoney(variant.compare_price);
        el.style.display = '';
      });
    } else {
      document.querySelectorAll('.price-compare').forEach(el => { el.style.display = 'none'; });
    }

    // 4. Mobil sticky bar fiyatı
    const stickyPrice = document.querySelector('.mob-sticky-buy__price');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    // 5. Buy Now linki — variant ID ekle
    const buyNow = document.getElementById('buyNow');
    if (buyNow) {
      const base = buyNow.getAttribute('href').split('?')[0];
      buyNow.href = base + '?variant=' + variant.id;
    }

    // 6. Seçilen boyutu sticky bar'da göster
    const stickyTitle = document.querySelector('.mob-sticky-buy__title');
    if (stickyTitle && variant.title && variant.title !== 'Default Title') {
      const productTitle = stickyTitle.dataset.baseTitle || stickyTitle.textContent;
      stickyTitle.dataset.baseTitle = stickyTitle.dataset.baseTitle || stickyTitle.textContent;
      stickyTitle.textContent = productTitle.split(' — ')[0] + ' — ' + variant.title;
    }
  }

  // Variant buton tıklama
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('variant-btn--active'));
        btn.classList.add('variant-btn--active');
        const variant = getSelectedVariant();
        if (variant) {
          applyVariant(variant);
        } else {
          console.warn('[KazeHaus] Variant eşleşmedi. Seçilen:', btn.dataset.value, '— Mevcut variantlar:', productVariants.map(v => v.option1));
        }
      });
    });
  });

  // Sayfa yüklenince ilk aktif variant'ı uygula
  (function initVariant() {
    // Aktif buton var mı kontrol et
    const hasActive = document.querySelector('.variant-btn--active');
    if (!hasActive) {
      // Yoksa ilk butonu aktif yap
      const firstBtn = document.querySelector('.variant-options .variant-btn');
      if (firstBtn) firstBtn.classList.add('variant-btn--active');
    }
    const variant = getSelectedVariant();
    if (variant) applyVariant(variant);
  })();
  const qtyInput = document.getElementById('productQty');
  document.getElementById('qtyMinus')?.addEventListener('click', () => { if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
  document.getElementById('qtyPlus')?.addEventListener('click',  () => { if (qtyInput) qtyInput.value = Math.min(99, parseInt(qtyInput.value) + 1); });

  /* ─────────────────────────────────────
     ESC
  ───────────────────────────────────── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCart(); closeMobileMenu(); closeUpsellPopup(); }
  });

  /* ─────────────────────────────────────
     NON-HOMEPAGE
  ───────────────────────────────────── */
  if (!document.body.classList.contains('template-index')) {
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
  }

  /* Init cart count on page load */
  fetch('/cart.js').then(r => r.json()).then(cart => {
    updateCartCounts(cart.item_count, cart.total_price);
    // Update mobile badge on load
    const mobBadge = document.getElementById('mobCartBadge');
    if (mobBadge) mobBadge.textContent = cart.item_count > 0 ? cart.item_count : '';
  }).catch(() => {});

  /* Re-render cart drawer content when language changes, if open */
  document.addEventListener('carina:langchange', () => {
    if (cartDrawer?.classList.contains('open')) refreshCartDrawer();
  });

  /* Mobile nav cart button */
  document.getElementById('mobCartBtn')?.addEventListener('click', () => {
    openCart();
  });

});

/* ─────────────────────────────────────
   MOBILE STICKY BUY — Show/hide on scroll
───────────────────────────────────── */
const mobStickyBuy = document.getElementById('mobStickyBuy');
const productBuyWrap = document.querySelector('.product-buy-wrap');
if (mobStickyBuy && productBuyWrap) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      // Show sticky bar when original button is out of view
      mobStickyBuy.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    });
  }, { threshold: 0.1 });
  observer.observe(productBuyWrap);
}

/* Update mobile cart badge count */
document.addEventListener('carina:cartUpdated', e => {
  const badge = document.getElementById('mobCartBadge');
  if (badge && e.detail?.count !== undefined) {
    badge.textContent = e.detail.count > 0 ? e.detail.count : '';
  }
});

/* ─────────────────────────────────────
   MOBILE — Swipeable product gallery
───────────────────────────────────── */
const mainImg = document.getElementById('mainImage');
const thumbContainer = document.querySelector('.product-thumbs');
if (mainImg && thumbContainer && window.innerWidth <= 768) {
  let touchStartX = 0;
  let currentImgIdx = 0;
  const thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  
  mainImg.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  
  mainImg.addEventListener('touchend', e => {
    const dx = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(dx) < 50) return;
    if (dx > 0 && currentImgIdx < thumbs.length - 1) currentImgIdx++;
    else if (dx < 0 && currentImgIdx > 0) currentImgIdx--;
    thumbs[currentImgIdx]?.click();
    // Scroll thumb into view
    thumbs[currentImgIdx]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
}

/* ── Mobile collection grid dots sync ── */
const collMobileGrid = document.getElementById('collMobileGrid');
if (collMobileGrid) {
  const mobileDots = document.querySelectorAll('.coll-mobile-dot');
  mobileDots.forEach(dot => {
    dot.addEventListener('click', () => {
      const page = parseInt(dot.dataset.page);
      collMobileGrid.scrollTo({ left: page * collMobileGrid.offsetWidth, behavior: 'smooth' });
    });
  });
  collMobileGrid.addEventListener('scroll', () => {
    const page = Math.round(collMobileGrid.scrollLeft / collMobileGrid.offsetWidth);
    mobileDots.forEach((d,i) => d.classList.toggle('active', i === page));
  }, { passive: true });
}

/* ═══════════════════════════════════════
   PRODUCT CARD CAROUSELS — dot sync & tap to navigate
═══════════════════════════════════════ */
(function initProductCarousels() {
  function setupCarousel(carousel) {
    const wrap = carousel.closest('.product-card__img-wrap');
    const dots = wrap?.querySelectorAll('.pc-dot');
    const productUrl = carousel.dataset.productUrl;

    // Dot sync on scroll
    if (dots?.length) {
      carousel.addEventListener('scroll', () => {
        const w = carousel.offsetWidth;
        const idx = Math.round(carousel.scrollLeft / w);
        dots.forEach((d, i) => d.classList.toggle('active', i === idx));
      }, { passive: true });
    }

    // Tap left/right half to navigate images (mobile)
    carousel.addEventListener('click', e => {
      if (window.innerWidth > 768) return;
      const x = e.clientX - carousel.getBoundingClientRect().left;
      const half = carousel.offsetWidth / 2;
      const w = carousel.offsetWidth;
      const current = Math.round(carousel.scrollLeft / w);
      const total = carousel.querySelectorAll('.pc-carousel__slide').length;

      if (x > half && current < total - 1) {
        // Right tap → next image
        carousel.scrollTo({ left: (current + 1) * w, behavior: 'smooth' });
      } else if (x <= half && current > 0) {
        // Left tap → prev image
        carousel.scrollTo({ left: (current - 1) * w, behavior: 'smooth' });
      } else {
        // First or last and tapped matching side → go to product
        if (productUrl) window.location.href = productUrl;
      }
    });
  }

  // Init on load
  document.querySelectorAll('.pc-carousel').forEach(setupCarousel);

  // Init on dynamic content (upsell cards don't have carousels but future-proof)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => m.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        node.querySelectorAll?.('.pc-carousel').forEach(setupCarousel);
      }
    }));
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
